import { FC } from 'react'

import {
  DEFAULT_OPTIONAL_COLUMN_IDS,
  OPTIONAL_COLUMN_LABELS,
  PINNED_COLUMN_IDS,
  PINNED_COLUMN_LABELS,
} from './trackerColumnConfig'
import { useTrackerMapContext } from './TrackerMapContext'

type TrackerColumnsSelectorProps = {
  onClose: () => void
}

// Column picker for the tracker list. Shipment/Status/Alert are pinned (always shown, not removable);
// the remaining columns can be toggled here and reordered by dragging their headers. Changes apply
// immediately and are persisted to the user's profile via the context.
export const TrackerColumnsSelector: FC<TrackerColumnsSelectorProps> = ({ onClose }) => {
  const { visibleColumns, setVisibleColumns } = useTrackerMapContext()

  const toggle = (id: string) => {
    if (visibleColumns.includes(id)) {
      setVisibleColumns(visibleColumns.filter((c) => c !== id))
    } else {
      setVisibleColumns([...visibleColumns, id])
    }
  }

  return (
    <dialog className="modal modal-open">
      <div className="modal-box max-w-sm">
        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onClose}>
          ✕
        </button>
        <h3 className="font-bold text-lg">Customize Columns</h3>
        <p className="text-xs text-base-content/60 mt-1">
          Shipment, Status and Alert are always shown. Drag column headers to reorder.
        </p>

        <div className="flex flex-col gap-0.5 mt-3">
          {PINNED_COLUMN_IDS.map((id) => (
            <label key={id} className="flex items-center gap-2 py-1 opacity-60 cursor-not-allowed">
              <input type="checkbox" checked disabled className="checkbox checkbox-xs checkbox-primary" />
              <span>{PINNED_COLUMN_LABELS[id]}</span>
              <span className="text-xs text-base-content/50">(locked)</span>
            </label>
          ))}

          <div className="divider my-1" />

          {DEFAULT_OPTIONAL_COLUMN_IDS.map((id) => (
            <label key={id} className="flex items-center gap-2 py-1 cursor-pointer hover:font-semibold">
              <input
                type="checkbox"
                checked={visibleColumns.includes(id)}
                onChange={() => toggle(id)}
                className="checkbox checkbox-xs checkbox-primary"
              />
              <span>{OPTIONAL_COLUMN_LABELS[id]}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-between items-center mt-4">
          <button
            className="btn btn-sm btn-ghost text-error"
            onClick={() => setVisibleColumns([...DEFAULT_OPTIONAL_COLUMN_IDS])}
          >
            Reset to Default
          </button>
          <button className="btn btn-sm btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onClose}>close</button>
      </form>
    </dialog>
  )
}
